<template>
	<b-dropdown class="menu-user-dropdown userMenuDrop" no-flip>
		<template v-slot:button-content>
			<span class="span-element" >
				<span style="width: 184px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
				<UserIcon class="mr-2"/>{{ userName }}
				</span>
				<span class="message-number" v-if="unreadMessages">{{unreadMessages}}</span>

				<ChevronDownIcon />
			</span>
		</template>
		<!-- ADMIN -->
		<b-dropdown-item
			v-if="isAdmin"
			href="#"
			:to="$i18nRoute({ name: 'admin-dashboard' })"
		>
			<ViewDashboardIcon />
			{{ $t('home.admin') }}
		</b-dropdown-item>
		<b-dropdown-item
			v-if="isAdmin"
			href="#"
			:to="$i18nRoute({ name: 'add-customer' })"
		>
			<ViewDashboardIcon />
			{{ $t('home.manageAds') }}
		</b-dropdown-item>
		<!-- USER -->
		<b-dropdown-item
			v-if="!isAdmin"
			href="#"
			:to="$i18nRoute({ name: 'user-dashboard' })"
		>
			<ViewDashboardIcon />
			{{ $t('userDashboard.navigation.controlPanel') }}
		</b-dropdown-item>
		<b-dropdown-item :to="$i18nRoute({ name: 'user-profile' })" v-if="!isAdmin">
			<EditIcon />
			{{ $t('home.profile') }}
		</b-dropdown-item>
		<b-dropdown-item :to="$i18nRoute({ name: 'message' })" v-if="!isAdmin">
			<MessageOutlineIcon />
			{{ $t('home.message') }}
			<span class="message-number" v-if="unreadMessages">{{unreadMessages}}</span>
		</b-dropdown-item>
		<b-dropdown-item :to="$i18nRoute({ name: 'user-manage' })" v-if="!isAdmin">
			<FormatListBulletedIcon />
			{{ $t('userDashboard.navigation.mylisting') }}
		</b-dropdown-item>
		<b-dropdown-item :to="$i18nRoute({ name: 'user-payment' })" v-if="!isAdmin">
			<CreditCardOutlineIcon />
			{{ $t('userDashboard.navigation.payment') }}
		</b-dropdown-item>
		<b-dropdown-item :to="$i18nRoute({ name: 'coins' })" v-if="!isAdmin">
			<span class="mif-coins"></span>
			{{ $t('userDashboard.navigation.thaiRathCoin') }}
		</b-dropdown-item>
		<b-dropdown-item
			:to="$i18nRoute({ name: 'user-statistic' })"
			v-if="!isAdmin"
		>
			<TrendingUpIcon />
			{{ $t('userDashboard.navigation.statistics') }}
		</b-dropdown-item>
		<b-dropdown-item :to="$i18nRoute({ name: 'user-contact' })" v-if="!isAdmin">
			<EmailIcon />
			{{ $t('userDashboard.navigation.contactAndReport') }}
		</b-dropdown-item>
		<b-dropdown-item v-if="agencyData.status==3||agencyData.logo_url&&!isAdmin"
			:to="$i18nRoute({ name: 'user-manage-agents' })"
			
		>
			<IconPlus />
			{{ $t('userDashboard.navigation.agents') }}
		</b-dropdown-item>
		<!-- LOG OUT -->
		<b-dropdown-item id="logout" @click="userLogout">
			<IconLogout />
			{{ $t('userDashboard.navigation.logout') }}
		</b-dropdown-item>
	</b-dropdown>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';

// Icons
import UserIcon from '@/components/icons/IconUser/index';
import ViewDashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import MessageOutlineIcon from 'vue-material-design-icons/MessageOutline.vue';
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import CreditCardOutlineIcon from 'vue-material-design-icons/CreditCardOutline.vue';
import TrendingUpIcon from 'vue-material-design-icons/TrendingUp.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import EditIcon from '@/components/icons/IconEdit/index';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import IconLogout from '@/components/icons/IconLogout/index';
import IconPlus from '@/components/icons/IconPlus';

export default {
	components: {
		UserIcon,
		ViewDashboardIcon,
		MessageOutlineIcon,
		FormatListBulletedIcon,
		TrendingUpIcon,
		CreditCardOutlineIcon,
		EmailIcon,
		EditIcon,
		ChevronDownIcon,
		IconLogout,
		IconPlus
	},
	props: {
		userName: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			isAdmin:
				localStorage.getItem('user_profile') &&
				JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'
					? true
					: false
		};
	},
	methods: {
		...mapActions('ChatController', ['GET_NUMBER_OF_UNREAD_MESSAGE']),
		userLogout() {
			this.$root.signOut();
		}
	},
	computed:{
		...mapGetters('AdminAgencyController', ['agencyData']),
		...mapGetters('ChatController', ['unreadMessages']),
	},
	mounted(){
		let _this=this;
		this.GET_NUMBER_OF_UNREAD_MESSAGE({admin:JSON.parse(localStorage.getItem('user_profile')).admin_type.name ==
					'Admin'? true:false})
	}
};
</script>

<style lang="scss">
.menu-user-dropdown.userMenuDrop {
	margin-right: 15px;
	.dropdown-toggle {
		width: 234px;
		color: var(--projectPrimaryColor);
		background: $white;
		border-radius: var(--borderRadius);
		border: 1px solid var(--projectPrimaryColor) !important;
		height: 40px;
		text-align: left;
		padding: 0 20px;
		&::after {
			content: unset;
		}
		&:active{
			color: var(--projectPrimaryColor) !important;
			background: $white;
			border-radius: var(--borderRadius);
			border: 1px solid var(--projectPrimaryColor) !important;
		}
		.chevron-down-icon {
			position: absolute;
			right: 20px;
			top: 8px;
		}
		.account-outline-icon {
			margin-right: 10px;
		}
		> span {
			> svg {
				width: 16px;
				height: 16px;
				margin-right: 15px;
				margin-top: -2px;
			}
		}
	}
	.dropdown-menu {
		> li {
			> .dropdown-item {
				padding: 10px 20px;
				color: #444444;
				font-size: 16px;
				@media (max-width: 992px) {
					font-size: 18px;
				}
				background: $white;
				white-space: unset;
				display: -webkit-box;
				display: -ms-flexbox;
				display: flex;
				-webkit-box-pack: flex-start;
				-ms-flex-pack: flex-start;
				justify-content: flex-start;
				-webkit-box-align: center;
				-ms-flex-align: center;
				align-items: center;
				&:hover {
					background-color: #f8f9fa;
				}
				> span,
				svg {
					margin-right: 10px;
				}
				> svg {
					width: 16px;
					height: 16px;
					stroke: #444444;
				}
			}
		}
	}
	&.show {
		.dropdown-toggle {
			border-radius: 20px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
		}
		.dropdown-menu {
			&.show {
				right: 0px;
				top: -10px !important;
				left: 0px;
				will-change: transform;
				border: 1px solid var(--projectPrimaryColor) !important;
				border-top: 0!important;
				border-radius: 0;
			}
		}
	}
	.span-element {
		width: 100%;
    	display: flex;
		// display: -webkit-box;
		// display: -ms-flexbox;
		// display: flex;
		// -webkit-box-pack: center;
		// -ms-flex-pack: center;
		// justify-content: space-between;
	}
	.message-number {
		font-size: 10px;
		background: #dc3849;
		color: #fff;
		border-radius: 50%;
		width: 17px;
		height: 17px;
		/* position: absolute; */
		padding-top: 2px;
		/* padding-left: 2px; */
		margin-left: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
